import { isDefined } from '@sgme/fp';
import { Tooltip } from '@sgme/ui';
import { Fragment, type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { blotterSlice } from '@/store/blotter/slice.ts';
import { useAppSelector } from '@/store/hooks.ts';

export const BlotterErrorIndication = () => {
  const status = useAppSelector(blotterSlice.selectors.getStatus);
  const impairments = useAppSelector(blotterSlice.selectors.getImpairments);

  if (status === 'unregistered' || status === 'registering') {
    return null;
  }

  if (status === 'registration failed') {
    const contents = <FormattedMessage id="blotter.error.registrationFailed" />;
    return <ErrorDisplay contents={contents} />;
  }

  if (isDefined(impairments) && impairments.length > 0) {
    const contents = [] as ReactNode[];
    if (impairments.includes('initial trades not loaded')) {
      contents.push(
        <Fragment key="trades">
          <FormattedMessage key="trades" id="blotter.error.trades" />
          <br />
        </Fragment>,
      );
    }
    if (impairments.includes('initial orders not loaded')) {
      contents.push(
        <Fragment key="orders">
          <FormattedMessage key="orders" id="blotter.error.orders" />
          <br />
        </Fragment>,
      );
    }
    return <ErrorDisplay contents={contents} />;
  }

  return null;
};

const ErrorDisplay = ({ contents }: { contents: ReactNode }) => {
  const effectivecontents = (
    <>
      <p className="text-start">{contents}</p>
      <p>
        <br />
        <FormattedMessage id="blotter.error.contactSupport" />
      </p>
    </>
  );
  return (
    <Tooltip position="bottom" contents={effectivecontents}>
      <span className="fs-12 text-danger" style={{ cursor: 'default' }}>
        <i className="icon icon-sm line-height-1 btn-group">error_outline</i> <FormattedMessage id="error" />
      </span>
    </Tooltip>
  );
};
